import React from 'react'
import styled from 'styled-components'
import {Icon} from '@startlibs/components'
import {getColor} from '@startlibs/utils'
import {Card, PageContainer} from '../components/PageLayout'
import {Header} from '../components/Header'
import iconsMap from '../../../purview-design/src/refs/Icons'

// Icon component expects names without the "icon-" prefix used in Icons.tsx
const ALL_ICON_NAMES = Object.keys(iconsMap).map(name => name.replace(/^icon-/, ''))

const IconsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 12px;
`

const IconTile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 8px;
  border: 1px solid ${getColor('gray220')};
  border-radius: 8px;
  background: #fff;
  min-height: 88px;
`

const IconName = styled.div`
  font-size: 11px;
  color: ${getColor('gray130')};
  text-align: center;
  word-break: break-word;
`

export const IconsPage = () => (
  <PageContainer>
    <Header title="Icons" />
    <Card>
      <IconsGrid>
        {ALL_ICON_NAMES.map(iconName => (
          <IconTile key={iconName}>
            <Icon icon={iconName} css="font-size: 20px;" />
            <IconName>{iconName}</IconName>
          </IconTile>
        ))}
      </IconsGrid>
    </Card>
  </PageContainer>
)
